import React from 'react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  return <section className="py-20 px-4" data-id="element-241">
      <div className="max-w-5xl mx-auto text-center" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-243">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 text-accent mb-6" data-id="element-244">
            <span className="text-3xl" data-id="element-245">🏆</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4" data-id="element-246">
            SABER-DIGITAL™ MEGAPACK IA LISTO
          </h2>
          <p className="text-xl md:text-2xl text-brand font-semibold mb-2" data-id="element-247">
            6 Tomos + 6 Bonos + AI OS — Principiante → Avanzado
          </p>
          <p className="text-lg text-muted mb-12" data-id="element-248">
            480+ páginas — Todo resuelto.
          </p>

          {/* Sequence visualizer */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-249">
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-250">
              <div className="text-2xl mb-2" data-id="element-251">📘</div>
              <div className="font-bold text-white mb-1" data-id="element-252">Tomo 1</div>
              <div className="text-xs text-muted" data-id="element-253">Fundamentos</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-254">
              <div className="text-2xl mb-2" data-id="element-255">📗</div>
              <div className="font-bold text-white mb-1" data-id="element-256">Tomo 2</div>
              <div className="text-xs text-muted" data-id="element-257">Prompts</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-258">
              <div className="text-2xl mb-2" data-id="element-259">📙</div>
              <div className="font-bold text-white mb-1" data-id="element-260">Tomo 3</div>
              <div className="text-xs text-muted" data-id="element-261">Productividad</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-262">
              <div className="text-2xl mb-2" data-id="element-263">📕</div>
              <div className="font-bold text-white mb-1" data-id="element-264">Tomo 4</div>
              <div className="text-xs text-muted" data-id="element-265">Marketing</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-266">
              <div className="text-2xl mb-2" data-id="element-267">📓</div>
              <div className="font-bold text-white mb-1" data-id="element-268">Tomo 5</div>
              <div className="text-xs text-muted" data-id="element-269">Aprendizaje</div>
            </div>
            <div className="bg-surface border border-border rounded-xl p-4 text-center" data-id="element-270">
              <div className="text-2xl mb-2" data-id="element-271">📔</div>
              <div className="font-bold text-white mb-1" data-id="element-272">Tomo 6</div>
              <div className="text-xs text-muted" data-id="element-273">Plan 30D</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}